import React, { FC } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getLenderState } from 'store/selectors/lenders.selector';

import { COMMON_POSTFIX, LENDERS, TAB_CONTENT_MAP, TAB_CONTENT_TITLES } from './common.const';

export const TabContent: FC = () => {
  const { pathname } = useLocation();
  const lender = useSelector(getLenderState);
  const lenderName = lender?.uiName || lender?.name;

  const title = pathname?.includes(LENDERS)
    ? `${lenderName} ${COMMON_POSTFIX}`
    : TAB_CONTENT_MAP.get(pathname) || TAB_CONTENT_TITLES.STREAMLINE;

  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
      </Helmet>
    </HelmetProvider>
  );
};
